<template>
	<div class="authc-home account-page">
	</div>
</template>

<script>
  export default {
    name: 'UserAuth',
    data(){
      return {

      }
    },
    methods:{
      getAuthInfo(){
        this.$api.user.getAuthFinishInfo().then(res=>{
          console.log(res)
		  localStorage.setItem('USER_AUTH', res.data.auth)
          if ( res.code === 0){
            if (res.data.auth === 10){
              // 个人已认证
			  this.$router.replace({name:'AuthFinish'})
            }else if(res.data.auth === 20){
              // 企业已认证
			  // this.$router.replace({name:'AuthcSelect'})
			  this.$router.replace({name:'AuthFinish'})
            }else if(res.data.auth === 0){
              // 未认证
              this.$router.replace({name:'AuthcSelect'})
            }else if(res.data.auth === 1){
              // 个人认证中
			  this.$router.replace({name:'AuthcUser'})
            }else if(res.data.auth === 2 || res.data.auth === 5){
              // 企业认证中
			  this.$router.replace({name:'AuthcEnt'})
            }
          }else{
            this.$message.error(res.msg)
          }
        })
      }
    },
    created(){
      console.log('home created')
      this.getAuthInfo()
    },
  }
</script>

<style scoped>

</style>
